/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.tsx to modify the generation of this file.
import React from 'react'
import Loadable from 'react-loadable'
const BodyBottomAnalytics = Loadable({
  loader: () => import(/* webpackChunkName: "BodyBottomAnalytics" */ '../../src/Feature/Analytics/BodyBottomAnalytics'),
  loading: () => null,
  modules: ['./BodyBottomAnalytics'],
  });
const BodyTopAnalytics = Loadable({
  loader: () => import(/* webpackChunkName: "BodyTopAnalytics" */ '../../src/Feature/Analytics/BodyTopAnalytics'),
  loading: () => null,
  modules: ['./BodyTopAnalytics'],
  });
const ApplicationInsightsScripts = Loadable({
  loader: () => import(/* webpackChunkName: "ApplicationInsightsScripts" */ '../../src/Feature/Diagnostics/ApplicationInsightsScripts'),
  loading: () => null,
  modules: ['./ApplicationInsightsScripts'],
  });
const ErrorMessageWrapper = Loadable({
  loader: () => import(/* webpackChunkName: "ErrorMessageWrapper" */ '../../src/Feature/HeaderFooter/ErrorMessageWrapper'),
  loading: () => null,
  modules: ['./ErrorMessageWrapper'],
  });
const FooterZone = Loadable({
  loader: () => import(/* webpackChunkName: "FooterZone" */ '../../src/Feature/HeaderFooter/FooterZone'),
  loading: () => null,
  modules: ['./FooterZone'],
  });
const FooterZoneV2 = Loadable({
  loader: () => import(/* webpackChunkName: "FooterZoneV2" */ '../../src/Feature/HeaderFooter/FooterZoneV2'),
  loading: () => null,
  modules: ['./FooterZoneV2'],
  });
const HeaderZone = Loadable({
  loader: () => import(/* webpackChunkName: "HeaderZone" */ '../../src/Feature/HeaderFooter/HeaderZone'),
  loading: () => null,
  modules: ['./HeaderZone'],
  });
const HeaderZoneV2 = Loadable({
  loader: () => import(/* webpackChunkName: "HeaderZoneV2" */ '../../src/Feature/HeaderFooter/HeaderZoneV2'),
  loading: () => null,
  modules: ['./HeaderZoneV2'],
  });
const LiveChat = Loadable({
  loader: () => import(/* webpackChunkName: "LiveChat" */ '../../src/Feature/HeaderFooter/LiveChat'),
  loading: () => null,
  modules: ['./LiveChat'],
  });
const MagazinesSignUpModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesSignUpModule" */ '../../src/Feature/Magazines/MagazinesSignUpModule'),
  loading: () => null,
  modules: ['./MagazinesSignUpModule'],
  });
const MagazinesArchiveBrowserModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesArchiveBrowserModule" */ '../../src/Feature/Magazines/StoryArchive/MagazinesArchiveBrowserModule'),
  loading: () => null,
  modules: ['./MagazinesArchiveBrowserModule'],
  });
const MagazinesArchiveHeaderModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesArchiveHeaderModule" */ '../../src/Feature/Magazines/StoryArchive/MagazinesArchiveHeaderModule'),
  loading: () => null,
  modules: ['./MagazinesArchiveHeaderModule'],
  });
const MagazinesArchiveWrapperModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesArchiveWrapperModule" */ '../../src/Feature/Magazines/StoryArchive/MagazinesArchiveWrapperModule'),
  loading: () => null,
  modules: ['./MagazinesArchiveWrapperModule'],
  });
const MagazinesStoriesArchiveAnalytics = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesStoriesArchiveAnalytics" */ '../../src/Feature/Magazines/StoryArchive/MagazinesStoriesArchiveAnalytics'),
  loading: () => null,
  modules: ['./MagazinesStoriesArchiveAnalytics'],
  });
const MagazinesArticleHeaderModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesArticleHeaderModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesArticleHeaderModule'),
  loading: () => null,
  modules: ['./MagazinesArticleHeaderModule'],
  });
const MagazinesArticleWrapper = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesArticleWrapper" */ '../../src/Feature/Magazines/StoryDetail/MagazinesArticleWrapper'),
  loading: () => null,
  modules: ['./MagazinesArticleWrapper'],
  });
const MagazinesDoubleImagesModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesDoubleImagesModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesDoubleImagesModule'),
  loading: () => null,
  modules: ['./MagazinesDoubleImagesModule'],
  });
const MagazinesInlineVideoModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesInlineVideoModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesInlineVideoModule'),
  loading: () => null,
  modules: ['./MagazinesInlineVideoModule'],
  });
const MagazinesInstagramEmbedModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesInstagramEmbedModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesInstagramEmbedModule'),
  loading: () => null,
  modules: ['./MagazinesInstagramEmbedModule'],
  });
const MagazinesLanguageFallbackWrapper = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesLanguageFallbackWrapper" */ '../../src/Feature/Magazines/StoryDetail/MagazinesLanguageFallbackWrapper'),
  loading: () => null,
  modules: ['./MagazinesLanguageFallbackWrapper'],
  });
const MagazinesListItemModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesListItemModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesListItemModule'),
  loading: () => null,
  modules: ['./MagazinesListItemModule'],
  });
const MagazinesQuoteModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesQuoteModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesQuoteModule'),
  loading: () => null,
  modules: ['./MagazinesQuoteModule'],
  });
const MagazinesRelatedArticlesModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesRelatedArticlesModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesRelatedArticlesModule'),
  loading: () => null,
  modules: ['./MagazinesRelatedArticlesModule'],
  });
const MagazinesRelatedArtistsModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesRelatedArtistsModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesRelatedArtistsModule'),
  loading: () => null,
  modules: ['./MagazinesRelatedArtistsModule'],
  });
const MagazinesRelatedDepartmentsModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesRelatedDepartmentsModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesRelatedDepartmentsModule'),
  loading: () => null,
  modules: ['./MagazinesRelatedDepartmentsModule'],
  });
const MagazinesRelatedLotsModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesRelatedLotsModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesRelatedLotsModule'),
  loading: () => null,
  modules: ['./MagazinesRelatedLotsModule'],
  });
const MagazinesRelatedSalesModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesRelatedSalesModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesRelatedSalesModule'),
  loading: () => null,
  modules: ['./MagazinesRelatedSalesModule'],
  });
const MagazinesRichTextModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesRichTextModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesRichTextModule'),
  loading: () => null,
  modules: ['./MagazinesRichTextModule'],
  });
const MagazinesShorthandArticleWrapper = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesShorthandArticleWrapper" */ '../../src/Feature/Magazines/StoryDetail/MagazinesShorthandArticleWrapper'),
  loading: () => null,
  modules: ['./MagazinesShorthandArticleWrapper'],
  });
const MagazinesShorthandModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesShorthandModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesShorthandModule'),
  loading: () => null,
  modules: ['./MagazinesShorthandModule'],
  });
const MagazinesSingleImageModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesSingleImageModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesSingleImageModule'),
  loading: () => null,
  modules: ['./MagazinesSingleImageModule'],
  });
const MagazinesStoryDetailAnalytics = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesStoryDetailAnalytics" */ '../../src/Feature/Magazines/StoryDetail/MagazinesStoryDetailAnalytics'),
  loading: () => null,
  modules: ['./MagazinesStoryDetailAnalytics'],
  });
const MagazinesTextBannerModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesTextBannerModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesTextBannerModule'),
  loading: () => null,
  modules: ['./MagazinesTextBannerModule'],
  });
const MagazinesXEmbedModule = Loadable({
  loader: () => import(/* webpackChunkName: "MagazinesXEmbedModule" */ '../../src/Feature/Magazines/StoryDetail/MagazinesXEmbedModule'),
  loading: () => null,
  modules: ['./MagazinesXEmbedModule'],
  });
const BottomScripts = Loadable({
  loader: () => import(/* webpackChunkName: "BottomScripts" */ '../../src/Feature/Scripts/BottomScripts'),
  loading: () => null,
  modules: ['./BottomScripts'],
  });
const HeadScripts = Loadable({
  loader: () => import(/* webpackChunkName: "HeadScripts" */ '../../src/Feature/Scripts/HeadScripts'),
  loading: () => null,
  modules: ['./HeadScripts'],
  });
const BasicMetaTags = Loadable({
  loader: () => import(/* webpackChunkName: "BasicMetaTags" */ '../../src/Feature/Seo/BasicMetaTags'),
  loading: () => null,
  modules: ['./BasicMetaTags'],
  });
const Favicons = Loadable({
  loader: () => import(/* webpackChunkName: "Favicons" */ '../../src/Feature/Seo/Favicons'),
  loading: () => null,
  modules: ['./Favicons'],
  });
const OpenGraphMetaTags = Loadable({
  loader: () => import(/* webpackChunkName: "OpenGraphMetaTags" */ '../../src/Feature/Seo/OpenGraphMetaTags'),
  loading: () => null,
  modules: ['./OpenGraphMetaTags'],
  });
const HeroBanner = Loadable({
  loader: () => import(/* webpackChunkName: "HeroBanner" */ '../../src/Feature/Test/HeroBanner'),
  loading: () => null,
  modules: ['./HeroBanner'],
  });
const TestZoneWrapper = Loadable({
  loader: () => import(/* webpackChunkName: "TestZoneWrapper" */ '../../src/Feature/Test/TestZoneWrapper'),
  loading: () => null,
  modules: ['./TestZoneWrapper'],
  });
const SkipLinksTarget = Loadable({
  loader: () => import(/* webpackChunkName: "SkipLinksTarget" */ '../../src/Foundation/Accessibility/SkipLinksTarget'),
  loading: () => null,
  modules: ['./SkipLinksTarget'],
  });
const V2020SkipLinks = Loadable({
  loader: () => import(/* webpackChunkName: "V2020SkipLinks" */ '../../src/Foundation/Accessibility/V2020SkipLinks'),
  loading: () => null,
  modules: ['./V2020SkipLinks'],
  });
const PartialDesignDynamicPlaceholder = Loadable({
  loader: () => import(/* webpackChunkName: "PartialDesignDynamicPlaceholder" */ '../../src/Foundation/PartialDesignDynamicPlaceholder'),
  loading: () => null,
  modules: ['./PartialDesignDynamicPlaceholder'],
  });

const components = new Map();
components.set('BodyBottomAnalytics', BodyBottomAnalytics);
components.set('BodyTopAnalytics', BodyTopAnalytics);
components.set('ApplicationInsightsScripts', ApplicationInsightsScripts);
components.set('ErrorMessageWrapper', ErrorMessageWrapper);
components.set('FooterZone', FooterZone);
components.set('FooterZoneV2', FooterZoneV2);
components.set('HeaderZone', HeaderZone);
components.set('HeaderZoneV2', HeaderZoneV2);
components.set('LiveChat', LiveChat);
components.set('MagazinesSignUpModule', MagazinesSignUpModule);
components.set('MagazinesArchiveBrowserModule', MagazinesArchiveBrowserModule);
components.set('MagazinesArchiveHeaderModule', MagazinesArchiveHeaderModule);
components.set('MagazinesArchiveWrapperModule', MagazinesArchiveWrapperModule);
components.set('MagazinesStoriesArchiveAnalytics', MagazinesStoriesArchiveAnalytics);
components.set('MagazinesArticleHeaderModule', MagazinesArticleHeaderModule);
components.set('MagazinesArticleWrapper', MagazinesArticleWrapper);
components.set('MagazinesDoubleImagesModule', MagazinesDoubleImagesModule);
components.set('MagazinesInlineVideoModule', MagazinesInlineVideoModule);
components.set('MagazinesInstagramEmbedModule', MagazinesInstagramEmbedModule);
components.set('MagazinesLanguageFallbackWrapper', MagazinesLanguageFallbackWrapper);
components.set('MagazinesListItemModule', MagazinesListItemModule);
components.set('MagazinesQuoteModule', MagazinesQuoteModule);
components.set('MagazinesRelatedArticlesModule', MagazinesRelatedArticlesModule);
components.set('MagazinesRelatedArtistsModule', MagazinesRelatedArtistsModule);
components.set('MagazinesRelatedDepartmentsModule', MagazinesRelatedDepartmentsModule);
components.set('MagazinesRelatedLotsModule', MagazinesRelatedLotsModule);
components.set('MagazinesRelatedSalesModule', MagazinesRelatedSalesModule);
components.set('MagazinesRichTextModule', MagazinesRichTextModule);
components.set('MagazinesShorthandArticleWrapper', MagazinesShorthandArticleWrapper);
components.set('MagazinesShorthandModule', MagazinesShorthandModule);
components.set('MagazinesSingleImageModule', MagazinesSingleImageModule);
components.set('MagazinesStoryDetailAnalytics', MagazinesStoryDetailAnalytics);
components.set('MagazinesTextBannerModule', MagazinesTextBannerModule);
components.set('MagazinesXEmbedModule', MagazinesXEmbedModule);
components.set('BottomScripts', BottomScripts);
components.set('HeadScripts', HeadScripts);
components.set('BasicMetaTags', BasicMetaTags);
components.set('Favicons', Favicons);
components.set('OpenGraphMetaTags', OpenGraphMetaTags);
components.set('HeroBanner', HeroBanner);
components.set('TestZoneWrapper', TestZoneWrapper);
components.set('SkipLinksTarget', SkipLinksTarget);
components.set('V2020SkipLinks', V2020SkipLinks);
components.set('PartialDesignDynamicPlaceholder', PartialDesignDynamicPlaceholder);

export default function componentFactory(componentName: string) {
  return components.get(componentName);
};
